import { adminHttpClient } from '../../commons/adminHttpClient'
import SubscriptionFrequency from '../common/subscriptionFrequency'

export interface IchraAdminSignupWizardState {
  companyName: string
  ein: string
  discountCode: string | null
  planCode: string | null
  isAle: boolean
  subscriptionPackageCode: string
  phoneNumber: {
    mainPhoneNumber: string
    workPhoneNumber: string
  }
  address: {
    stateId: string
    addressLine1: string
    addressLine2: string | null
    city: string
    zipCode: string
  }
  serviceAgreement: boolean
  frequency: SubscriptionFrequency
  companyTypeId: number | null
  seatNumber: number
}

const ichraStateApi = (): Promise<IchraAdminSignupWizardState> => {
  return adminHttpClient.get('/AdminSignup/ichra/Wizard/State')
}

export default ichraStateApi
